import React from 'react';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
// import Section0 from './section0';
import Section1 from './section1';
interface IWelcomeTopicProps {
  settings: any;
}

const WelcomeTopic: React.FunctionComponent<IWelcomeTopicProps> = ({
  settings,
}) => (
  <TopicContainer className="welcome">
    <TopicItem className="welcome-bg" id="1">
      <Section1 settings={settings} />
      {/*<Section0 settings={settings} />*/}
    </TopicItem>
  </TopicContainer>
);

export default WelcomeTopic;
